import {Routes} from '@angular/router';
import {LoadCourseDetailResolver} from '../services/load-course-detail.resolver';
import {UploadOngoingGuard} from './services/upload-ongoing.guard';
import {DripScheduleConfigService} from '../services/drip-schedule-config.service';

export const editCoursesRoutes: Routes = [
  {
    path: ':courseUrl/edit',
    // switcher picks the redesigned builder shell or the classic editor from the tenant flag.
    // The path must keep '/edit-courses/' — LoadCourseDetailResolver derives isAdminRoute from it.
    loadComponent: () => import('../course-builder/editor/edit-course-switcher/edit-course-switcher.component')
      .then(m => m.EditCourseSwitcherComponent),
    resolve: {
      course: LoadCourseDetailResolver
    },
    canDeactivate: [UploadOngoingGuard],
    providers: [
      UploadOngoingGuard,
      DripScheduleConfigService
    ],

  },
];
